import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import { Aniversario } from '../../services/contratos/index';
import classNames from 'classnames';
import { Dropdown } from 'primereact/dropdown';
import './styles.css';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const statuses = [
    'Ativo', 'Suspenso', 'Cancelado'
];

export default class niverAssociados extends Component {
    state = {
        teste: null,
        dados: [],
        selectedStatus: null,
        loading: 'loading',
        submit: ''
    }

    async componentWillMount() {
        this.setState({ loading: 'nada',
            submit: true });

        const codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;

        await Aniversario(codigo)
            .then(resp => {
                if (resp != null) {
                    for (let i = 0; i < resp.length; i++) {
                        if (resp[i]['Nascimento'] != null) {
                            resp[i].Nascimento = moment(resp[i]['Nascimento']).add(3, 'hours').format('DD-MM-YYYY');
                        }

                        if (resp[i].status === 1)
                        {resp[i].status = 'Ativo';}

                        if (resp[i].status === 2)
                        {resp[i].status = 'Suspenso';}

                        if (resp[i].status === 3) {
                            resp[i].status = 'Cancelado';
                        } else {
                            resp.status = '';
                        }
                    }
                }

                this.setState({ dados: resp });
                this.setState({ loading: 'loading',
                    submit: false });
            })
            .catch(err => {
                this.setState({ loading: 'loading',
                    submit: true });
            });
    }

    formatData() {
        const data = this.state.dados;
        let datamoment;

        data.forEach(value => {
            const dataformat = value.Nascimento;

            datamoment = moment(dataformat).add(3, 'hours').format('DD/MM/YYYY');

            return datamoment;
        });
    }

    renderHeader() {
        return (
            <div className="p-grid p-fluid" style={{ background: '#F4C27A',
                alignItems: 'left' }}>
                <div className="p-col-6 p-md-6">
                    <h2>Associados que fazem aniversario este mês</h2>
                </div>
                <div className="p-col-6 p-md-6">

                </div>
            </div>
        );
    }

    statusBodyTemplate = rowData => <span className={classNames('customer-badge', `status-${  rowData.status}`)}>
        {rowData.status}
    </span>

    onStatusFilterChange = event => {
        this.dt.filter(event.value, 'status', 'equals');
        this.setState({ selectedStatus: event.value });
    }

    renderStatusFilter() {
        return (
            <Dropdown value={this.state.selectedStatus} options={statuses} onChange={this.onStatusFilterChange}
                itemTemplate={this.statusItemTemplate} showClear={true} placeholder="Escolha o Status" className="p-column-filter" />
        );
    }

    inscricaoBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Inscrição</span>
                {rowData.Inscricao}
            </React.Fragment>
        );
    }

    nomeBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Nome</span>
                {rowData.Nome}
            </React.Fragment>
        );
    }

    nascimentoBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Nascimento</span>
                {moment(rowData.Nascimento, ['DD-MM-YYYY']).add(3, 'hours').format('DD/MM/YYYY')}
            </React.Fragment>
        );
    }

    telefoneBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">Telefone</span>
                {rowData.Telefone}
            </React.Fragment>
        );
    }

    assEmailBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <span className="p-column-title">E-mail</span>
                {rowData.AssEmail}
            </React.Fragment>
        );
    }

    render() {
        const statusFilter = this.renderStatusFilter();
        const header = this.renderHeader();

        return (
            <>
                <div className={this.state.loading}>
                    <ProgressSpinner style={{ width: '800px',
                        height: '250px' }} strokeWidth="1" fill="#EEEEEE" animationDuration=".5s" />
                </div>
                { this.state.submit !== true ?
                    <div className="datatable-responsive-demo">
                        <div className="card">
                            <DataTable
                                header={header}
                                ref={el => this.dt = el}
                                autoLayout={true}
                                selection={this.state.dados}
                                value={this.state.dados}
                                paginator={true}
                                rows={10}
                                sortField="data"
                                sortOrder={1}
                                className="p-datatable-responsive-demo"
                            >
                                <Column
                                    field="Inscricao"
                                    header="Inscricao"
                                    sortable={true}
                                    body={this.inscricaoBodyTemplate}
                                />
                                <Column
                                    field="Nome"
                                    header="Nome"
                                    sortable={true}
                                    body={this.nomeBodyTemplate}
                                />
                                <Column
                                    field="Nascimento"
                                    header="Nascimento"
                                    sortable={true}
                                    body={this.nascimentoBodyTemplate}
                                />
                                <Column
                                    field="Telefone"
                                    header="Telefone"
                                    sortable={true}
                                    body={this.telefoneBodyTemplate}
                                />
                                <Column
                                    field="AssEmail"
                                    header="Email"
                                    sortable={true}
                                    body={this.assEmailBodyTemplate}
                                />
                                <Column field="status" header="Status" body={this.statusBodyTemplate} sortable filter filterElement={statusFilter} />
                            </DataTable>
                        </div>
                    </div> :
                    null}
            </>

        );
    }
}
